import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface AdminTransaction {
    id: number;
    userId: number;
    userEmail: string;
    type: string;
    typeLabel: string;
    amount: number;
    description: string;
    entityId: number | null;
    entityType: string | null;
    adminId: number | null;
    status: string;
    statusLabel: string;
    purchaseId: number | null;
    createdAt: string;
}

export interface AdminTransactionsListResponse {
    transactions: AdminTransaction[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export function useAdminTransactions(
    page = 1,
    limit = 20,
    userId?: number,
    type?: string
) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    if (userId) {
        params.set('user_id', String(userId));
    }

    if (type) {
        params.set('type', type);
    }

    return useQuery<AdminTransactionsListResponse>({
        queryKey: ['admin', 'transactions', page, limit, userId, type],
        queryFn: () => api.get(`/api/admin/credits/transactions?${params}`),
    });
}
